// components/category/UrgentFilter.tsx
'use client';

import { useRouter, useSearchParams, usePathname } from 'next/navigation';
import { useCallback } from 'react';

export function UrgentFilter() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const isUrgent = searchParams.get('urgentOnly') === 'true';

  const handleUrgentToggle = useCallback(() => {
    const params = new URLSearchParams(searchParams.toString());
    if (!isUrgent) {
      params.set('urgentOnly', 'true');
    } else {
      params.delete('urgentOnly');
    }
    router.push(`${pathname}?${params.toString()}`);
  }, [isUrgent, pathname, router, searchParams]);

  return (
    <div className="flex items-center gap-3 mb-4 flex-wrap sm:flex-nowrap">
      <button
        role="switch"
        aria-checked={isUrgent}
        onClick={handleUrgentToggle}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 ${
          isUrgent ? 'bg-primary-600' : 'bg-gray-200'
        }`}
      >
    <span
      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
        isUrgent ? 'translate-x-6' : 'translate-x-1'
      }`}
    />
      </button>
      <span
        className="text-sm text-gray-700 cursor-pointer"
        onClick={handleUrgentToggle}
      >
    Zeige nur sofort buchbare Angebote von Guides, die innerhalb der nächsten 2 Stunden verfügbar sind
  </span>
    </div>
  );
}